import { Box, type BoxProps } from '../Box'
import { visuallyHidden } from '../util.css'

/** @deprecated */
export const AccessibilityText = (props: Pick<BoxProps, 'children' | 'as'>) => (
  <Box {...props} className={visuallyHidden} />
)
